import { View } from "react-native"
import { cn } from "@/components/util/cn"
import BFText from "@/components/standard/BFText"

export const OrDivider = ({ hide = false }: { hide?: boolean }) => (
  <View className={cn("py-[26px]", hide && "hidden")}>
    <View className="flex flex-row items-center">
      <View className="flex flex-1 h-px bg-white" />
      <BFText className="px-4 text-white font-figtree-extrabold text-[12px] leading-[16px] h-[16px]">
        Or
      </BFText>
      <View className="flex flex-1 h-px bg-white" />
    </View>
  </View>
)
